

var $8a3f3ff86fe8bdb8$exports = {};
$8a3f3ff86fe8bdb8$exports = import.meta.resolve("4DZMx");


if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    navigator.serviceWorker.register($8a3f3ff86fe8bdb8$exports).catch((err)=>{
        console.warn('Service worker registration failed:', err);
    });
});


//# sourceMappingURL=path0.d0a601c1.js.map
